"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@popperjs/core");
var animejs_1 = __importDefault(require("animejs"));
var air_datepicker_1 = __importDefault(require("air-datepicker"));
var en_1 = __importDefault(require("air-datepicker/locale/en"));
// today
var today = new Date();
function datepicker(querySelector, livewireEmit) {
    if (document.querySelectorAll(querySelector).length) {
        return new air_datepicker_1.default(querySelector, {
            locale: en_1.default,
            minDate: today,
            maxDate: new Date(today.getTime() + 364 * 24 * 60 * 60 * 1000),
            position: function (_a) {
                var $datepicker = _a.$datepicker, $target = _a.$target, $pointer = _a.$pointer, isViewChange = _a.isViewChange, done = _a.done;
                // TypeScript: $datepicker, $target, $pointer are HTMLElement
                var popper = (0, core_1.createPopper)($target, $datepicker, {
                    placement: "bottom",
                    onFirstUpdate: function () {
                        if (!isViewChange)
                            animejs_1.default.remove($datepicker);
                        $datepicker.style.transformOrigin =
                            "center top";
                        if (!isViewChange) {
                            (0, animejs_1.default)({
                                targets: $datepicker,
                                opacity: [0, 1],
                                rotateX: [-90, 0],
                                easing: "spring(1.3, 80, 5, 0)",
                            });
                        }
                    },
                    modifiers: [
                        { name: "offset", options: { offset: [0, 10] } },
                        {
                            name: "arrow",
                            options: { element: $pointer },
                        },
                        {
                            name: "computeStyles",
                            options: { gpuAcceleration: false },
                        },
                    ],
                });
                return function () {
                    (0, animejs_1.default)({
                        targets: $datepicker,
                        opacity: 0,
                        rotateX: -90,
                        duration: 300,
                        easing: "easeOutCubic",
                    }).finished.then(function () {
                        popper.destroy();
                        done();
                    });
                };
            },
            onSelect: function (_a) {
                var date = _a.date, formattedDate = _a.formattedDate, datepicker = _a.datepicker;
                var today = new Date();
                var oneDay = 1000 * 60 * 60 * 24;
                // Ensure we have a single Date
                var selectedDate;
                if (Array.isArray(date)) {
                    selectedDate = date[0]; // take first if array
                }
                else {
                    selectedDate = date;
                }
                if (!selectedDate)
                    return; // safety check
                var days = Math.ceil((selectedDate.getTime() - today.getTime()) / oneDay) +
                    1;
                // Emit to Livewire
                window.livewire.emit(livewireEmit, days);
                // Update input value
                var input = document.querySelector(querySelector);
                if (input)
                    input.value = days.toString();
            },
        });
    }
}
exports.default = datepicker;
